<template>
	<BaseInput
		ref="BaseInput"
		v-model="model"
		:label="label"
		:error-message="errorMessage"
		:required="required"
		:sublabel="sublabel"
		type="radio"
		v-bind="$attrs"
		:is-toggleable="isToggleable"
	>
		<template #default="slotProps">
			<fieldset class="space-y-4">
				<BaseRadio
					ref="BaseRadioForm.BaseRadio"
					:disabled="slotProps.disabled"
					v-for="option in options"
					@input="value = $event"
					:value="option.value"
					:label="option.display"
					:form-value="value"
					:key="option.label"
					@click="selectOption($event)"
					:class="option.class"
				>
					<template #[`input_${option.display}`]>
						<slot :name="`input_${option.display}`" />
					</template>
				</BaseRadio>
			</fieldset>
		</template>
	</BaseInput>
</template>

<script>
import BaseInput from '@/components/forms/inputs/BaseInput';
import BaseRadio from '@/components/forms/inputs/BaseRadio';
import Validate from '@/mixins/Validate';

export default {
	name: 'BaseRadioForm',
	components: { BaseRadio, BaseInput },
	mixins: [Validate],
	props: {
		sublabel: {},
		label: {},
		errorMessage: {},
		required: {},
		disabled: {},
		value: {},
		options: {
			type: Array,
		},
		isToggleable: { default: false },
		allowEmpty: { default: false },
		filterOnly: { default: false },
	},
	methods: {
		selectOption(option) {
			if (option === this.model && this.allowEmpty) {
				this.model = null;
			} else {
				this.model = option;
			}
		},
	},
	computed: {
		model: {
			get() {
				return this.value;
			},
			set(v) {
				if (!this.filterOnly) {
					this.$store.commit('setConfirmLeaving', this.$t('leave_page'));
				}
				this.$emit('input', v);
			},
		},
	},
};
</script>

<style scoped></style>
